// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-two-column {
  display: grid;
  grid-template-columns: var(--admin-sidebar-w) minmax(0, 1fr);
  min-height: calc(100vh - var(--admin-shell-top) - var(--admin-shell-rail));
  background: transparent;
}

.au-two-column__sidebar,
.au-two-column__main {
  min-width: 0;
}

.au-two-column__main {
  padding: var(--admin-s5) var(--admin-shell-pad-x);
}

@media (max-width: 960px) {
  .au-two-column {
    grid-template-columns: minmax(0, 1fr);
  }

  .au-two-column__main {
    padding-top: var(--admin-s4);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminTwoColumn.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,4DAA4D;EAC5D,0EAA0E;EAC1E,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".au-two-column {\n  display: grid;\n  grid-template-columns: var(--admin-sidebar-w) minmax(0, 1fr);\n  min-height: calc(100vh - var(--admin-shell-top) - var(--admin-shell-rail));\n  background: transparent;\n}\n\n.au-two-column__sidebar,\n.au-two-column__main {\n  min-width: 0;\n}\n\n.au-two-column__main {\n  padding: var(--admin-s5) var(--admin-shell-pad-x);\n}\n\n@media (max-width: 960px) {\n  .au-two-column {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .au-two-column__main {\n    padding-top: var(--admin-s4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
